export default __webpack_public_path__ + "static/media/image-3.12af56e1.webp";